<template>
    <div class="module-g">
        <div class="msg-form">
            <div class="mf-users">
                <div class="tet-a">收信人</div>
                <multi-items-input style="width: 100%" v-model="addressList" :height="34" separator=";" :selection-only="false" ></multi-items-input>
            </div>
            <div class="mf-content">
                <div class="tet-a">内容</div>
                <el-input type="textarea" v-model="msgContent" rows="16"></el-input>
            </div>
            <!-- <div class="mf-tool">
                <span style="margin: 0px 20px 0px 0px;font-size: 14px">发送方式: </span>
                <el-radio v-model="msgType" :label="true">站内信</el-radio>
                <el-radio v-model="msgType" :label="false">短信</el-radio>
            </div> -->
            <div class="mf-btn">
                <el-button type="primary" size="small" @click="submitFormMsg">发 送</el-button>
            </div>
        </div>
        <div class="contacts">
            <div class="c-title">
                <div style="color: #606266;">联系人</div>
                <div style="color: #3d6fd8;cursor: pointer;user-select: none" v-on:click="groupStatusTap">{{groupStatus ? '退出编辑' : '编辑'}}</div>
            </div>
            <div class="c-tools" v-show="groupStatus">
                <div class="ct-i" v-on:click="handleAddGroup">新建分组</div>
                <div class="ct-i" v-on:click="handleBatchDeleteGroup">批量删除</div>
            </div>
            <ul class="group">
                <template v-for="(groupItem, groupIndex) in groupData">
                    <li :key="groupIndex" class="g-item">
                        <ul class="gi-title">
                            <li class="frc">
                                <i :class="groupItem.expand ? 'el-icon-caret-bottom' : 'el-icon-caret-right'" v-on:click="groupNameTap(groupItem)"></i>
                                <img class="icon-a" v-show="groupStatus" v-bind:src="groupItem.checked ? checkedTrue : checkedFalse" alt="" v-on:click="groupNameCheckedTap(groupItem)">
                                <div class="txt-b" v-on:click="groupNameTap(groupItem)">{{groupItem.groupName}}</div>
                            </li>
                            <li class="frc" v-show="groupStatus">
                                <img class="icon-a" src="@/assets/edit02.png" alt="" v-on:click="handleEditGroup(groupItem)"/>
                                <img class="icon-a" src="@/assets/add10.png" alt="" v-on:click="handleAddUser(groupItem)" />
                                <img class="icon-a" src="@/assets/del02.png" alt="" v-on:click="handleDeleteGroup(groupItem)"/>
                            </li>
                            <!--
                            <li v-show="!groupStatus">
                                <img class="icon-b" src="@/assets/add02.png" alt="" v-on:click="handleAddressList(0, groupItem.msgUserGroupList)"/>
                            </li>
                            -->
                        </ul>
                        <el-collapse-transition>
                            <ul class="gi-user" v-show="groupItem.expand">
                                <template v-for="(userItem, userIndex) in groupItem.msgUserGroupList">
                                    <li :key="userIndex" class="gu-item">
                                        <span class="txt-b">{{userItem.userName}}</span>
                                        <img class="icon-b" v-show="!groupStatus" src="@/assets/add02.png" alt="" v-on:click="handleAddressList(1, userItem)" />
                                    </li>
                                </template>
                            </ul>
                        </el-collapse-transition>
                    </li>
                </template>
            </ul>
        </div>
        <el-dialog :title="dialogTitleGroup == 0 ? '新建分组' : '编辑分组'" :visible.sync="dialogVisibleGroup" :close-on-click-modal="false" width="20%">
            <el-form ref="formInfoGroup" :rules="formInfoGroupRules" :model="formInfoGroup" label-width="100px">
                <el-form-item label="名称" prop="groupName">
                    <el-input v-model="formInfoGroup.groupName" clearable />
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="resetFormGroup('formInfoGroup')">取 消</el-button>
                <el-button type="primary" @click="submitFormGroup('formInfoGroup')">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="选择联系人" :visible.sync="dialogVisible" :close-on-click-modal="false" width="30%">
            <div class="toolsb">
                <el-input class="mb-input" placeholder="请输入姓名" v-model="query.nickName"></el-input>
                <el-button type="primary" @click="toQuery">搜索</el-button>
                <el-button type="primary" @click="resetQuery">重置</el-button>
                <div style="margin: 10px 0px 0px 10px">已选择 <span style="color: #3d6fd8">{{multipleSelection.length}}</span> 人</div>
            </div>

            <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" :stripe="true" :header-cell-style="tableHeaderCellStyle" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55"/>
                <el-table-column prop="userId" label="序号" align="center"/>
                <el-table-column prop="nickName" label="姓名" align="center"/>
                <el-table-column prop="classerName" label="所属班级" align="center"/>
            </el-table>
            <el-pagination class="mb-pagination" :current-page="curPage" layout="total, prev, pager, next" :total="total" @current-change="handleCurrentChange"></el-pagination>
            <div slot="footer">
                <el-button @click="resetForm">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import CommonStyle from "@/utils/CommonStyle";
    export default {
        name: "Contacts",
        data() {
            return {
                tableHeaderCellStyle: CommonStyle.tableHeaderCellStyle,
                checkedFalse: require("@/assets/checked_false.png"),
                checkedTrue: require("@/assets/checked_true.png"),

                msgType: true,
                groupStatus: false,

                addressList: [],
                msgContent: "",

                groupData: [],
                groupDataItem: {
                    groupId: null
                },

                dialogVisibleGroup: false,
                dialogTitleGroup: 0,
                formInfoGroup: {},
                formInfoGroupRules: {
                    groupName: [
                        { required: true, message: "请输入", trigger: "blur" }
                    ]
                },

                dialogVisible: false,
                tableData: [],
                multipleSelection: [],
                multipleSelectionAll: [],
                query: {
                    nickName: ""
                },
                curPage: 1,
                total: 0
            };
        },
        mounted() {
            let that = this;
            that.queryDataGroup();
        },
        methods: {
            handleAddGroup() {
                this.dialogTitleGroup = 0;
                this.dialogVisibleGroup = true;
            },
            handleEditGroup(groupDataItem) {
                this.formInfoGroup = {
                    groupName: groupDataItem.groupName,
                    groupId: groupDataItem.groupId
                };
                this.dialogTitleGroup = 1;
                this.dialogVisibleGroup = true;
            },
            handleDeleteGroup(item) {
                let that = this;
                that.$confirm("确定要删除该条私信吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    that.HttpConnection.post(`/msg/group/delete/${item.groupId}`).then(function(response) {
                        that.$message({
                            type: "success",
                            message: "删除成功"
                        });
                    });
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
            },
            handleBatchDeleteGroup() {
                let that = this;
                that.$confirm("确定要删除该条私信吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    let _ids = [];
                    for (let item of that.groupData) {
                        if (item.checked) {
                            _ids.push(item.group);
                        }
                    }
                    that.HttpConnection.post("/msg/group/batchDelete", _ids).then(function(response) {
                        that.queryDataGroup();
                        that.$message({
                            type: "success",
                            message: "删除成功"
                        });
                    });
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
            },
            handleAddUser(groupDataItem) {
                let that = this;
                that.queryData();
                that.groupDataItem = groupDataItem;
                that.dialogVisible = true;
            },
            handleCurrentChange(val) {
                this.curPage = val;
                this.queryData();
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                this.multipleSelectionAll[this.curPage - 1] = val;
            },
            resetFormGroup(formInfoGroup) {
                this.dialogVisibleGroup = false;
                this.$refs[formInfoGroup].resetFields();
            },
            submitFormGroup(formInfoGroup) {
                let that = this;
                this.$refs[formInfoGroup].validate((valid) => {
                    if (valid) {
                        let _url = "";
                        if (this.dialogTitleGroup === 0) {
                            _url = "/msg/group/save";
                        } else if (this.dialogTitleGroup === 1) {
                            _url = "/msg/group/update";
                        }
                        that.HttpConnection.post(_url, that.formInfoGroup).then(function(response) {
                            that.dialogVisibleGroup = false;
                            that.$refs[formInfoGroup].resetFields();
                            that.queryDataGroup();
                            that.$message({
                                type: "success",
                                message: "操作成功"
                            });
                        });
                    } else {
                        console.log("error submit!!");
                        return false;
                    }
                });
            },
            /*
            * 发送信息
            * */
            submitFormMsg() {
                let that = this;
                if (that.addressList.length === 0) {
                    that.$message({
                        type: "warning",
                        message: "您还未选择联系人"
                    });
                    return;
                }
                if (that.msgContent === "") {
                    that.$message({
                        type: "warning",
                        message: "您还未填写内容"
                    });
                    return;
                }
                let _receiveUserId = [];
                for (let item of that.addressList) {
                    _receiveUserId.push(item.id);
                }
                that.HttpConnection.post("/msg/letter/save", {
                    sendNoticeIs: that.msgType, // true站内信; false短信
                    sendContent: that.msgContent,
                    receiveUserId: _receiveUserId.join(";")
                }).then(function(response) {
                    that.$message({
                        type: "success",
                        message: "发送成功!"
                    });
                });
            },
            /*
            * 为群组添加人员
            * */
            submitForm() {
                let that = this;
                let _multipleSelectionAll = that.multipleSelectionAll.reduce(function(a, b) {
                    return a.concat(b);
                });
                let _msgUserGroupList = [];
                for (let item of _multipleSelectionAll) {
                    _msgUserGroupList.push({
                        userId: item.userId,
                        userName: item.nickName
                    });
                }
                that.HttpConnection.post("/msg/user-group/batchSave", {
                    groupId: that.groupDataItem.groupId,
                    msgUserGroupList: _msgUserGroupList
                }).then(function(response) {
                    that.dialogVisible = false;
                    that.$refs.multipleTable.clearSelection();
                    that.queryDataGroup();
                });
            },
            resetForm() {
                this.dialogVisible = false;
                this.$refs.multipleTable.clearSelection();
            },
            queryData() {
                let that = this;
                that.HttpConnection.get("/system/user/getUserName", {
                    params: {
                        nickName: that.query.nickName,
                        pageNum: that.curPage,
                        pageSize: 10
                    }
                }).then(function(res) {
                    let resData = res.rows;
                    that.tableData = resData;
                    that.total = res.total;
                    that.$nextTick(function() {
                        for (let aIndex in resData) {
                            for (let groupItem of that.groupDataItem.msgUserGroupList) {
                                if (resData[aIndex].userId === groupItem.userId) {
                                    that.$refs.multipleTable.toggleRowSelection(resData[aIndex]);
                                }
                            }
                        }
                        that.multipleSelectionAll[that.curPage - 1] = that.multipleSelection;
                    });
                });
            },
            queryDataGroup() {
                let that = this;
                that.HttpConnection.get("/msg/group/list").then(function(res) {
                    that.groupData = res.data;
                });
            },
            toQuery() {
                this.queryData();
            },
            resetQuery() {
                this.query = {
                    nickName: ""
                };
                this.queryData();
            },
            groupNameTap(groupItem) {
                this.$set(groupItem, "expand", !groupItem.expand);
            },
            groupNameCheckedTap(groupItem) {
                this.$set(groupItem, "checked", !groupItem.checked);
            },
            /*
            * 添加发送目标（人员）
            * type: 0 Array
            * type: 1 Object
            * */
            handleAddressList(type, userInfo) {
                if (type === 0) {
                    console.log("");
                } else if (type === 1) {
                    this.$set(userInfo, "checked", !userInfo.checked);
                    if (userInfo.checked) {
                        this.addressList.push({
                            id: userInfo.userId,
                            name: userInfo.userName
                        });
                    } else {
                        let _index = null;
                        for (let index in this.addressList) {
                            if (this.addressList[index].id === userInfo.userId) {
                                _index = index;
                            }
                        }
                        this.$delete(this.addressList, _index);
                    }
                }
            },
            groupStatusTap() {
                this.groupStatus = !this.groupStatus;
            }
        }
    };
</script>

<style scoped lang="scss">
    .module-g{
        width: 930px;
        display: flex;
        flex-direction: row;
        margin-top: 20px;
    }
    .msg-form{
        flex-grow: 1;
        margin-right: 10px;
        padding: 20px;
        border: 1px solid #ebedf0;
        border-radius: 5px;
        background-color: #f5f7fa;
        .mf-users{
            display: flex;
            flex-direction: row;
            align-items: center;
        }
        .mf-content{
            display: flex;
            flex-direction: row;
            margin: 30px 0px 10px 0px;
        }
        .mf-btn{
            display: flex;
            flex-direction: row;
            justify-content: center;
        }
        .mf-tool{
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-end;
        }
    }
    .contacts{
        width: 260px;
        border: 1px solid #ebedf0;
        border-radius: 5px;
        background-color: #f5f7fa;
        .c-title{
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;
            padding: 14px 20px 14px 20px;
        }
        .c-tools{
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            color: #3d6fd8;
            font-size: 14px;
            padding: 4px 0px;
            margin: 16px 0px 0px 0px;
            border-top: 1px solid #ebedf0;
            border-bottom: 1px solid #ebedf0;
            .ct-i{
                color: #3d6fd8;
                margin: 0px 6px;
                cursor: pointer;
            }
        }
    }
    .group{
        padding: 0px 12px 0px 12px;
        .g-item{
            margin: 10px 0px;
        }
        .gi-title{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
        }
        .gi-user{
            padding: 0px 0px 0px 24px;
        }
        .gu-item{
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            margin: 6px 0px;
            padding: 4px 10px;
        }
        .icon-b{
            width: 16px;
            height: 16px;
            cursor: pointer;
            visibility: hidden;
        }
        .gu-item:hover{
            background-color: #e1e3e7;
        }
        .gu-item:hover .icon-b{
            visibility: visible;
        }
        .gi-title:hover .icon-b{
            visibility: visible;
        }
    }
    .tet-a{
        width: 54px;
        min-width: 54px;
        color: #606266;
        font-size: 14px;
    }
    .txt-b{
        width: 100px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
        user-select: none;
        font-size: 14px;
    }
    .icon-a{
        width: 16px;
        height: 16px;
        margin: 0px 5px 0px 0px;
        cursor: pointer;
    }
</style>
